/* eslint-disable sort-keys */
import {
    AGING_TANK,
    APPELLATION,
    BRAND,
    COUNTRY,
    DRINK_CATEGORY,
    NET_VOLUME,
    PREMIUM_PACK,
    PRODUCT_TYPE,
    REGION,
    STRONGNESS,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
    YEAR,
} from 'modules/product-card/constants/characteristics';
import {TCharacteristicList} from 'modules/product-card/types';

const HEADER: TCharacteristicList = [COUNTRY, REGION, BRAND, STRONGNESS, NET_VOLUME, PRODUCT_TYPE, PREMIUM_PACK];
const DETAILED = [AGING_TANK, YEAR, TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET = [...HEADER, ...DETAILED];

const DETAILED_GRAPPA_AKVAVIT = [DRINK_CATEGORY, AGING_TANK, TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET_GRAPPA_AKVAVIT = [...HEADER, ...DETAILED_GRAPPA_AKVAVIT];

export const KSN_CHARACTERISTICS = {HEADER, DETAILED, TABLET};

export const GRAPPA_AKVAVIT_CHARACTERISTICS = {
    HEADER,
    DETAILED: DETAILED_GRAPPA_AKVAVIT,
    TABLET: TABLET_GRAPPA_AKVAVIT,
};

const DETAILED_VODKA = [TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET_VODKA = [...HEADER, ...DETAILED_VODKA];

export const VODKA_CHARACTERISTICS = {
    HEADER,
    DETAILED: DETAILED_VODKA,
    TABLET: TABLET_VODKA,
};

const DETAILED_KALVADOS = [APPELLATION, AGING_TANK, TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET_KALVADOS = [...HEADER, ...DETAILED_KALVADOS];

export const KALVADOS_CHARACTERISTICS = {
    HEADER,
    DETAILED: DETAILED_KALVADOS,
    TABLET: TABLET_KALVADOS,
};
